import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";

class urlFieldForm extends React.Component {

    render() {
        return (
            <div className="col-md-12">
                <div className="form-group">
                    {this.props.presets.component_id ? <TextInput
                        name="title"
                        value={this.props.values.title}
                        label="Cím"
                        saveChanges={this.props.setFieldValue}
                        {...this.props.getFieldProps("title")}
                    /> : <div className="form-group">
                        <label className="control-label">Seo</label>
                        <div className="form-control">Kérlek mentsd el a seo létrehozásához!</div>
                    </div>}
                </div>
            </div>
        );
    }
}

export default createForm(urlFieldForm);
